module.exports = __webpack_public_path__ + "images/emoji/banana.d52fdcce8bb09ac1821c.png";